import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

// One nav definition, two renderings: a sidebar on desktop and a
// bottom tab bar on phones (plus a slim top bar for brand + sign out).
const NAV = [
  { to: '/app', label: 'Calendar', short: 'Calendar', icon: '📅', end: true },
  { to: '/app/inquiries', label: 'Inquiries', short: 'Inquiries', icon: '📨', end: false },
  { to: '/app/clients', label: 'Clients', short: 'Clients', icon: '🐕', end: false },
  { to: '/app/classes', label: 'Classes', short: 'Classes', icon: '🎓', end: false },
  { to: '/app/class-types', label: 'Class Types', short: 'Types', icon: '🏷️', end: false },
  { to: '/app/instructors', label: 'Instructors', short: 'Team', icon: '🧑‍🏫', end: false },
  { to: '/app/settings', label: 'Settings', short: 'Settings', icon: '⚙️', end: false },
];

export function AppLayout() {
  const { signOut } = useAuth();
  return (
    <div className="app-shell">
      {/* Desktop sidebar */}
      <nav className="sidebar">
        <div className="sidebar-brand">
          <img src="/img/logo.png" alt="" style={{ height: 30, width: 'auto' }} />
          <span>Top Dogs</span>
        </div>
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            <span className="nav-icon" aria-hidden>
              {item.icon}
            </span>
            <span>{item.label}</span>
          </NavLink>
        ))}
        <div className="sidebar-foot">
          <a className="nav-link" href="/" target="_blank" rel="noreferrer">
            <span className="nav-icon" aria-hidden>
              🌐
            </span>
            <span>View site</span>
          </a>
          <button className="btn btn-ghost btn-sm" onClick={() => void signOut()}>
            <span className="nav-icon" aria-hidden>
              ↩
            </span>
            <span>Sign out</span>
          </button>
        </div>
      </nav>

      {/* Mobile top bar */}
      <header className="mobile-top">
        <span className="mobile-brand">
          <img src="/img/logo.png" alt="" style={{ height: 30, width: 'auto' }} />
          <span>Top Dogs</span>
        </span>
        <div className="row" style={{ gap: '0.2rem' }}>
          <a
            className="btn btn-ghost btn-sm"
            href="/"
            target="_blank"
            rel="noreferrer"
            aria-label="View public site"
          >
            🌐
          </a>
          <button className="btn btn-ghost btn-sm" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </header>

      <main className="content">
        <Outlet />
      </main>

      {/* Mobile bottom tab bar */}
      <nav className="tabbar" aria-label="Primary">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `tab${isActive ? ' active' : ''}`}
          >
            <span className="tab-icon" aria-hidden>
              {item.icon}
            </span>
            <span className="tab-label">{item.short}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

// Shared page header with a title, optional subtitle, and right-aligned action.
export function PageHead({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="muted">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
